var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalenderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.332 2.7474H16.4154V1.83073C16.4154 1.32656 16.0029 0.914062 15.4987 0.914062C14.9945 0.914062 14.582 1.32656 14.582 1.83073V2.7474H5.41536V1.83073C5.41536 1.32656 5.00286 0.914062 4.4987 0.914062C3.99453 0.914062 3.58203 1.32656 3.58203 1.83073V2.7474H2.66536C1.65703 2.7474 0.832031 3.5724 0.832031 4.58073V19.2474C0.832031 20.2557 1.65703 21.0807 2.66536 21.0807H17.332C18.3404 21.0807 19.1654 20.2557 19.1654 19.2474V4.58073C19.1654 3.5724 18.3404 2.7474 17.332 2.7474ZM16.4154 19.2474H3.58203C3.07786 19.2474 2.66536 18.8349 2.66536 18.3307V7.33073H17.332V18.3307C17.332 18.8349 16.9195 19.2474 16.4154 19.2474Z",
    fill: "#51B15C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calenderIcon.98e0352e8d088745ed2b5dcf2142d1f6.svg";
export { ForwardRef as ReactComponent };